import { carrierNameOf, useCarriers } from '../../settings/carriers.ts';
import { namesOf, useGeoAreas } from '../../geography/useGeoAreas.ts';
import { usePageContext } from '../../usePageContext.ts';
import type { KeyNamer } from './breakdown-values.ts';
import type { BreakdownDimension } from './widget-queries.ts';
import type { WidgetContext } from './widget-types.ts';

const OTHER_KEY = 'other';
const UNKNOWN_KEY = 'unknown';

export const useBreakdownNames = (context: WidgetContext, dimension: BreakdownDimension): KeyNamer => {
  const { t } = usePageContext();
  const carriers = useCarriers(context.shipping).data?.items;
  const places = namesOf(useGeoAreas(context.api).data);
  const namers: Readonly<Record<BreakdownDimension, KeyNamer>> = {
    carrier: (key) => (key === UNKNOWN_KEY ? t('dashboard.widgets.noCarrier') : carrierNameOf(carriers, key)),
    governorate: (key) => (key === UNKNOWN_KEY ? t('dashboard.widgets.noGovernorate') : places(key)),
    source: (key) => t(`orders.source_${key === UNKNOWN_KEY ? 'none' : key}`),
    status: (key) => t(`statistics.orders_${key}`),
  };
  return (key) => (key === OTHER_KEY ? t('dashboard.widgets.other') : namers[dimension](key));
};
